import { inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { ElasticApmService } from '../services/elastic-apm.service';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';

export const errorLoggingInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const elasticApmService = inject(ElasticApmService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse) {
        elasticApmService.logError('intercepted-error', JSON.stringify(error), {
          method: req.method,
          url: req.url,
          status: error.status,
          params: req.params.toString(),
          body: JSON.stringify(req.body)
        });

        if (error.status === 403 || error.status === 401) {
          router.navigate(['/permissions-error']);
        }
      }

      return throwError(() => error);
    })
  );
};
